import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginSyncPlatformPage } from './login-sync-platform';

@NgModule({
  declarations: [
    LoginSyncPlatformPage,
  ],
  imports: [
    IonicPageModule.forChild(LoginSyncPlatformPage),
  ],
})
export class LoginSyncPlatformPageModule {}



// WEBPACK FOOTER //
// ./src/pages/login-sync-platform/login-sync-platform.module.ts